export default __webpack_public_path__ + "static/GGHO-5a6c0556362440befcaf0a9caa79741c.png";